export const TOKEN = 'TOKEN';
export const USER = 'USER';
export const SENDCODE = 'SENDCODE';
export const USERNAME = 'USERNAME';